import React from 'react';
export function Footer() {
  return <footer className="bg-navy text-white/50 py-6 md:py-8 px-5 text-center text-[12px] md:text-[13px]" data-id="element-63">
      <p data-id="element-64">⚖️ DEFENDETE — Megapack Ciudadano</p>
      <p className="mt-2" data-id="element-65">
        <a href="#" className="text-gold no-underline hover:underline" data-id="element-66">
          contacto@solucionesya.shop
        </a>{' '}
        ·{' '}
        <a href="#" className="text-gold no-underline hover:underline" data-id="element-67">
          solucionesya.shop
        </a>
      </p>
      <p className="mt-2" data-id="element-68">
        © solucionesya.shop 2026 — Todos los derechos reservados
      </p>
      <p className="mt-2 text-[11px] md:text-[12px] opacity-50" data-id="element-69">
        Este producto es de carácter informativo y no reemplaza el asesoramiento
        legal profesional.
      </p>
    </footer>;
}